'use client'

import dynamic from 'next/dynamic'
import Link from 'next/link'
import { motion } from 'framer-motion'
import { ArrowRight, Mail, Phone } from 'lucide-react'

const WireframeSphere = dynamic(() => import('@/components/three/WireframeSphere'), {
  ssr: false,
  loading: () => null,
})

export default function ContactCTA() {
  return (
    <section className="relative py-40 bg-[#0F172A] overflow-hidden">
      {/* subtle top border */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#C8A96E]/20 to-transparent" />

      {/* 3D sphere - centered behind */}
      <div className="absolute inset-0 flex items-center justify-center opacity-20 pointer-events-none">
        <WireframeSphere size={600} />
      </div>

      {/* Radial gradient overlay */}
      <div
        className="absolute inset-0"
        style={{
          background: 'radial-gradient(ellipse 60% 60% at 50% 50%, rgba(15,23,42,0.4) 0%, #0F172A 70%)',
        }}
      />

      <div className="relative z-10 max-w-[1200px] mx-auto px-6 text-center">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        >
          <div className="flex items-center justify-center gap-4 mb-8">
            <div className="w-12 h-px bg-[#C8A96E]" />
            <span
              className="text-[#C8A96E] text-xs tracking-[0.3em]"
              style={{ fontFamily: 'var(--font-space-mono, "Space Mono", monospace)' }}
            >
              GET IN TOUCH
            </span>
            <div className="w-12 h-px bg-[#C8A96E]" />
          </div>

          <h2
            className="text-[clamp(3rem,10vw,9rem)] leading-[0.9] text-[#F8FAFC] mb-8"
            style={{ fontFamily: 'var(--font-bebas, "Bebas Neue", cursive)', letterSpacing: '0.02em' }}
          >
            LET'S BUILD SOMETHING{' '}
            <span className="text-[#C8A96E]">REMARKABLE</span>
          </h2>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 mb-12">
            <a
              href="mailto:info@apexvisualtech.cloud"
              className="flex items-center gap-2 text-[#C8A96E] hover:text-[#D4BA8A] transition-colors text-base"
              style={{ fontFamily: 'var(--font-space-mono, "Space Mono", monospace)' }}
            >
              <Mail size={16} />
              info@apexvisualtech.cloud
            </a>
            <div className="hidden sm:block w-px h-4 bg-white/20" />
            {/* <span
              className="flex items-center gap-2 text-[#94A3B8] text-base"
              style={{ fontFamily: 'var(--font-space-mono, "Space Mono", monospace)' }}
            >
              <Phone size={16} />
              +91 XXXXX XXXXX
            </span> */}
          </div>

          <div className="flex flex-wrap items-center justify-center gap-4">
            <Link
              href="/contact"
              className="inline-flex items-center gap-2 bg-[#C8A96E] text-[#0F172A] px-10 py-4 text-sm font-bold tracking-[0.15em] hover:bg-[#D4BA8A] transition-colors duration-300"
              style={{ fontFamily: 'var(--font-space-mono, "Space Mono", monospace)' }}
            >
              START A PROJECT <ArrowRight size={14} />
            </Link>
            <Link
              href="/work"
              className="inline-flex items-center gap-2 border border-white/20 text-[#F8FAFC] px-10 py-4 text-sm tracking-[0.15em] hover:border-[#C8A96E]/40 hover:text-[#C8A96E] transition-colors duration-300"
              style={{ fontFamily: 'var(--font-space-mono, "Space Mono", monospace)' }}
            >
              VIEW OUR WORK <ArrowRight size={14} />
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  )
}
